import { render, staticRenderFns } from "./EmailConfigurationPanel.vue?vue&type=template&id=0a732479&"
import script from "./EmailConfigurationPanel.vue?vue&type=script&lang=js&"
export * from "./EmailConfigurationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports